import { z } from "zod";
import { LEVELS, RIGHTS_BASIS } from "../constants.js";

/** Campos complementares enviados junto com o PDF (multipart/form-data). */
export const ebookUploadSchema = z.object({
  title: z.string().trim().min(3, "Informe o título do curso.").max(160),
  audience: z.string().trim().max(300).optional().default(""),
  level: z.enum(LEVELS).default("beginner"),
  tone: z.string().trim().max(120).optional().default(""),
  workloadHours: z.coerce.number().int().min(1).max(400).optional(),
  rightsBasis: z.enum(RIGHTS_BASIS, { message: "Declare a titularidade ou a licença do ebook." }),
  rightsAccepted: z
    .union([z.literal("true"), z.literal(true)])
    .transform(() => true as const)
    .refine((v) => v, "Confirme a declaração de titularidade ou licença."),
});

export type EbookUploadInput = z.infer<typeof ebookUploadSchema>;
